import React from 'react';
import IconBase from './IconBase';

const CogIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M19.5,12c0-0.4-0.1-0.8-0.1-1.3l1.7-1.5C21.4,9,21.5,8.4,21.3,8l-1.2-2c-0.2-0.4-0.7-0.6-1.2-0.4l-2.1,0.7 c-0.6-0.5-1.4-1-2.2-1.3l-0.4-2.2c-0.1-0.5-0.5-0.8-1-0.8h-2.4c-0.5,0-0.9,0.3-1,0.8L9.4,5C8.6,5.3,7.9,5.7,7.2,6.2L5.1,5.5 C4.6,5.4,4.2,5.6,3.9,6L2.7,8C2.5,8.4,2.6,9,2.9,9.3l1.7,1.5c-0.1,0.4-0.1,0.8-0.1,1.3s0.1,0.8,0.1,1.3l-1.7,1.5 C2.6,15,2.5,15.6,2.7,16l1.2,2c0.2,0.4,0.7,0.6,1.2,0.4l2.1-0.7c0.6,0.5,1.4,1,2.2,1.3l0.4,2.2c0.1,0.5,0.5,0.8,1,0.8h2.4 c0.5,0,0.9-0.3,1-0.8l0.4-2.2c0.8-0.3,1.5-0.7,2.2-1.3l2.1,0.7c0.5,0.2,0.9,0,1.2-0.4l1.2-2c0.2-0.4,0.2-0.9-0.2-1.3l-1.7-1.5 C19.4,12.8,19.5,12.4,19.5,12z M12,16c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S14.2,16,12,16z"/>
        </IconBase>
    )
}

export default CogIcon;